import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import Select from "../select/Select";
export const CascadingSelect = ({ validationRules, formConfig, path, items }) => {
    const cascadingSelectFields = items ? items.map((item) => item.id) : [];
    formConfig?.watch?.([...cascadingSelectFields]);
    useEffect(() => {
        getCSVData({ filter_attributes: [], fetch_attribute: cascadingSelectFields[0] });
    }, []);
    const updateSelectValues = (id, values = []) => {
        const select = items ? items.find((item) => item.id === id) : null;
        if (select) {
            select.items = values;
        }
    };
    const onChangeCascadingSelect = async (id) => {
        const currentSelectIndex = cascadingSelectFields.indexOf(id.toString()) + 1;
        const selectsToUpdate = cascadingSelectFields.slice(currentSelectIndex);
        if (selectsToUpdate.length) {
            const selectValues = formConfig?.getValues([...cascadingSelectFields]).slice(0, currentSelectIndex);
            if (selectValues) {
                selectsToUpdate.forEach((select) => updateSelectValues(select));
                const filterAttributes = selectValues.map((value, index) => ({
                    name: cascadingSelectFields[index],
                    value: value,
                }));
                await getCSVData({ filter_attributes: filterAttributes, fetch_attribute: selectsToUpdate[0] });
            }
        }
    };
    const populateSelect = (results, id) => {
        const selectValues = results.map((result) => ({ id: id, subject: result }));
        updateSelectValues(id, selectValues);
        formConfig?.setValue?.(id, []);
    };
    const getCSVData = async (data) => {
        const response = await fetch(`${path}`, {
            method: "POST",
            body: JSON.stringify(data),
        });
        const content = await response.json();
        await populateSelect(content.data, data.fetch_attribute);
    };
    return (_jsx("div", { children: items?.map((cascadingField) => (_jsx(Select, { id: cascadingField.id, label: cascadingField.label, items: cascadingField.items, placeholder: cascadingField.placeholder, validationRules: validationRules, onChangeCascadingSelect: onChangeCascadingSelect, formConfig: formConfig }, cascadingField.id))) }));
};
export default CascadingSelect;
//# sourceMappingURL=CascadingSelect.js.map